<!--
 * @Author: wangjx
 * @LastEditors: yingna.gao
 * @Date: 2021-08-06 11:05:21
 * @LastEditTime: 2022-09-13 16:13:20
 * @Description: 添加、编辑角色
-->

<template>
  <div>
    <el-dialog
      v-dialogDrag
      :title="content.title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="527px"
      class="self-dialog-form"
    >
      <el-form
        ref="formRef"
        label-position="top"
        :rules="formRules"
        :model="formData"
        @submit.native.prevent
      >
        <el-form-item :label="$t('role.roleName')" prop="roleName">
          <el-input
            v-model="formData.roleName"
            :placeholder="$t('role.enterRoleName')"
            autocomplete="off"
            :max-length="64"
          />
        </el-form-item>
        <el-form-item :label="$t('role.roleCode')" prop="roleCode">
          <el-input
            v-model="formData.roleCode"
            :placeholder="$t('role.enterRoleCode')"
            autocomplete="off"
            maxlength="64"
          />
        </el-form-item>
        <el-form-item :label="$t('role.roleDescription')" prop="description">
          <el-input
            v-model="formData.description"
            type="textarea"
            :placeholder="$t('role.enterRoleDescription')"
            maxlength="200"
            :rows="4"
            show-word-limit
          ></el-input>
        </el-form-item>

        <!-- <el-form-item :label="$t('role.dataPermission')" prop="dataScopeType">
          <el-select
            v-model="formData.dataScopeType"
            :placeholder="$t('role.selectDataPermission')"
            style="width: 100%"
            @change="changeDataSource"
          >
            <el-option
              v-for="item in dataSource"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-show="showTransDept" :label="$t('role.dataScope')" prop="org">
          <el-select
            v-model="currentName"
            :placeholder="$t('role.selectDataDataScope')"
            multiple
            collapse-tags
            style="width: 100%"
            @change="selectChange"
            @visible-change="visibleChange"
          >
            <el-option style="width: 100%; height: auto" :value="selectData">
              <el-tree
                ref="tree"
                :data="orgTree"
                show-checkbox
                node-key="id"
                default-expand-all
                class="self-tree"
                :props="defaultProps"
                check-strictly
                :filter-node-method="filterNode"
                @check-change="handleCheckChange"
              >
                <span slot-scope="{ node }" :title="node.label" class="self-custom-tree">
                  <span>{{ node.label }}</span>
                </span>
              </el-tree>
            </el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading.sync="dialogLoading" @click="handleConfirm">
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { commonFilterNode } from "@/utils";

export default {
  name: "RoleDetail",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default() {
        return {};
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      formData: {
        // dataScope: []
      },
      formRules: {
        roleName: [
          { required: true, message: this.$t("role.enterRoleName"), trigger: "blur" },
          { required: true, message: this.$t("role.enterRoleName"), trigger: "change" }
        ],
        roleCode: [
          { required: true, message: this.$t("role.enterRoleCode"), trigger: "blur" },
          { required: true, message: this.$t("role.enterRoleCode"), trigger: "change" }
        ]
        // dataScopeType: [
        //   { required: true, message: this.$t('role.enterDataScopeType'), trigger: 'blur' },
        //   { required: true, message: this.$t('role.enterDataScopeType'), trigger: 'change' }
        // ]
      },
      //  [ALL:全部, CUSTOM:自定义, OWN_CHILD:本级及子级, OWN:本级, ONESELF:自己],可用值:ALL,CUSTOM,ONESELF,OWN,OWN_CHILD
      dataSource: [
        { label: "全部", value: "ALL" },
        { label: "本级及子级", value: "OWN_CHILD" },
        { label: "本级", value: "OWN" },
        { label: "自己", value: "ONESELF" },
        { label: "跨部门", value: "TRANS_DEPT" },
        { label: "自定义", value: "CUSTOM" }
      ],
      showTransDept: false,
      defaultProps: {
        children: "children",
        label: "orgName"
      },
      currentValue: [], // 当前被选中下拉框中的值
      selectData: [], // 下拉框中的选项数据
      orgTree: [],
      currentName: []
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },
    dialogLoading: {
      get() {
        return this.loading;
      },
      set(val) {
        this.$emit("update:loading", val);
      }
    }
  },
  created() {
    // this.orgTree = this.content.orgTree;
    if (this.content.type === "edit") {
      this.roleInitShow();
    }
    // else {
    //   this.formData = { dataScopeType: 'ALL' };
    // }
  },
  methods: {
    // 回显角色
    roleInitShow() {
      this.formData = JSON.parse(JSON.stringify(this.content.formData));
      // this.changeDataSource(this.formData.dataScopeType);
      // if (this.formData.dataScope) {
      //   const ids = this.formData.dataScope;
      //   // 通过id转换成对应的name
      //   this.currentValue = ids;
      //   this.handleData(ids, this.orgTree || []);
      // }
    },

    /**
     * @description: // 格式化usertree
     * @param {*} data
     * @param {*} level
     * @return {*}
     */
    handleData(userIds, orgTree) {
      return orgTree.map(o => {
        if (o.id) {
          userIds.forEach(element => {
            if (element === o.id) {
              this.currentName.push(o.orgName);
            }
          });
        }
        if (o.children && o.children.length) {
          this.handleData(userIds, o.children);
        }
      });
    },

    /**
     * @description: 确定
     * @param {*}
     * @return {*}
     */
    handleConfirm() {
      this.$refs.formRef &&
        this.$refs.formRef.validate(valid => {
          // if (this.formData.dataScopeType === 'TRANS_DEPT') {
          //   // 清空的情况赋值为空
          //   if (this.currentName && this.currentName === 0) {
          //     this.formData.dataScope = [];
          //   } else {
          //     // 没有清空赋值为当前值
          //     this.formData.dataScope = this.currentValue;
          //   }
          // } else {
          //   this.formData.dataScope = [];
          // }
          if (valid) {
            this.$emit("confirm", {
              type: this.content.type,
              data: this.formData
            });
          }
          this.dialogLoading = false;
        });
    },
    // 当值为跨部门显示组织结构为其他时隐藏
    changeDataSource(value) {
      if (value === "TRANS_DEPT") {
        this.showTransDept = true;
      } else {
        this.showTransDept = false;
      }
    },

    /**
     * @description: 筛选组织树
     * @param {*}
     * @return {*}
     */
    // 筛选组织树
    filterNode(value, data, node) {
      return commonFilterNode(value, data, node);
    },
    // 下拉框中的数据发生改变
    selectChange(data) {
      const arrNew = [];
      const orgLength = this.orgTree.length;
      const dataLength = data.length;
      for (let i = 0; i < orgLength; i++) {
        for (let j = 0; j < dataLength; j++) {
          if (data[j] === this.orgTree[i].id) {
            arrNew.push(this.orgTree[i]);
          }
        }
      }
      this.$refs.tree.setCheckedNodes(arrNew); // 设置勾选的值
    },

    visibleChange(data) {
      if (data && this.currentValue) {
        this.$refs.tree.setCheckedKeys(this.currentValue); // 设置勾选的值
      }
    },
    // 树型结构选项框被点击发生改变
    handleCheckChange() {
      const checkeArr = this.$refs.tree.getCheckedNodes();
      // 通过id获取名称
      const arrLabel = [];
      const arr = [];
      const arrIds = [];
      if (checkeArr && checkeArr.length > 0) {
        checkeArr.forEach((item, index) => {
          arrLabel.push(item.orgName);
          arr.push(item);
          arrIds.push(item.id);
        });
        this.currentName = arrLabel; // select
        this.currentValue = arrIds;
        this.selectData = arr; // option
      }
    }
  }
};
</script>

<style></style>
